export const pagesTitles = {
  soc_media: 'Social Media',
  coupons: 'Coupons',
  vcard_plus: 'vCard Plus',
  business_page: 'Business Page',
  feedback: 'Feedback',
  rating: 'Rating',
  video: 'Video',
  event: 'Event',
  pdf: 'PDF',
  // facebook: 'Facebook',
  app: 'App',
  // mp3: 'MP3',
  menu: 'Menu',
  images: 'Images',
}

export const pageComponents = {
  L2QrPageWebsite: () =>
    import(/* webpackChunkName: "website page" */ '@/components/pages/Website'),
  L2QrPageSocialMedia: () =>
    import(
      /* webpackChunkName: "social media page" */ '@/components/pages/SocialMedia'
    ),
  L2QrPageCoupons: () =>
    import(/* webpackChunkName: "coupons page" */ '@/components/pages/Coupons'),
  L2QrPageVCardPlus: () =>
    import(/* webpackChunkName: "vCard page" */ '@/components/pages/VCardPlus'),
  L2QrPageBusinessPage: () =>
    import(
      /* webpackChunkName: "business page" */ '@/components/pages/BusinessPage'
    ),
  L2QrPageFeedback: () =>
    import(
      /* webpackChunkName: "feedback page" */ '@/components/pages/Feedback'
    ),
  L2QrPageRating: () =>
    import(/* webpackChunkName: "rating page" */ '@/components/pages/Rating'),
  L2QrPageVideo: () =>
    import(/* webpackChunkName: "video page" */ '@/components/pages/Video'),
  L2QrPageEvent: () =>
    import(/* webpackChunkName: "event page" */ '@/components/pages/Event'),
  L2QrPagePdf: () =>
    import(/* webpackChunkName: "pdf page" */ '@/components/pages/Pdf'),
  // L2QrPageFacebook: () =>
  //   import(
  //     /* webpackChunkName: "facebook page" */ '@/components/warning-pages/Facebook'
  //   ),
  L2QrPageApp: () =>
    import(/* webpackChunkName: "app page" */ '@/components/pages/App'),
  // L2QrPageMp3: () =>
  //   import(/* webpackChunkName: "mp3 page" */ '@/components/warning-pages/Mp3'),
  L2QrPageImages: () =>
    import(/* webpackChunkName: "images page" */ '@/components/pages/Images'),
  L2QrPageMenu: () =>
    import(/* webpackChunkName: "menu page" */ '@/components/pages/Menu'),
  L2QrPageInstagram: () =>
    import(
      /* webpackChunkName: "instagram page" */ '@/components/pages/Instagram'
    ),
}

export const pageComponentsNames = {
  URL: 'L2QrPageWebsite',
  soc_media: 'L2QrPageSocialMedia',
  coupons: 'L2QrPageCoupons',
  vcard_plus: 'L2QrPageVCardPlus',
  business_page: 'L2QrPageBusinessPage',
  feedback: 'L2QrPageFeedback',
  rating: 'L2QrPageRating',
  video: 'L2QrPageVideo',
  event: 'L2QrPageEvent',
  pdf: 'L2QrPagePdf',
  // facebook: 'L2QrPageFacebook',
  app: 'L2QrPageApp',
  // mp3: 'L2QrPageMp3',
  images: 'L2QrPageImages',
  menu: 'L2QrPageMenu',
  instagram: 'L2QrPageInstagram',
}
